import React, { useEffect, Fragment, useState } from 'react';
import { Box, Typography, List, ListItem, TextField, Chip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { KpiActions } from './KpiActions';
import { KpiProgressBarMain } from '../MyProgress/KpiProgressBarMain';
import { removeLocalStorageItem } from '../../../services/StorageService';
import { ErrorIcon } from '../../../config/svg/formElementIcons';
import { Enums } from '../../../config/enums';

const AddNewKpiKr: React.FC<any> = (props: any) => {
	const {
		okrMasterData,
		objData,
		newKeyList,
		setNewKeyList,
		userDetail,
		updateProgress,
		t,
		showLoader,
		setShowLoader,
		handleNewKeyResultChange,
	} = props;
	const [errorOpen, setErrorOpen] = useState<boolean>(false);

	const [updatedNewKRList, setUpdatedNewKRList] = useState<any>(newKeyList);

	useEffect(() => {
		// This will use to update Add new KR Start and End date if we updated OKR date
		const updatedList =
			newKeyList && newKeyList.length > 0
				? newKeyList.map((item: any) => {
						return {
							...item,
							dateRange: item?.dateRange || null,
						};
				  })
				: newKeyList;
		setUpdatedNewKRList(updatedList);
		setTimeout(() => {
			removeLocalStorageItem('updatedGoalObjId');
		}, 2000);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newKeyList]);
	const { progressPopupOpenKrId } = useSelector((state: any) => state.okrReducer);
	return (
		<>
			{newKeyList &&
				newKeyList.length > 0 &&
				newKeyList.map((keyData: any, keyIndex: number) => (
					<Box className='okr-listing-wrapper kr-listing-content'>
						<Box className='okr-listing-wrapper-inner'>
							<List component='ul'>
								<ListItem className='okr-col1'>
									<Box className='add-kr-textfield'>
										<Box className='kr-field'>
											<TextField
												className='add-kr helperText-bottom'
												id={`create_default_kr_field_index_${keyIndex}`}
												multiline
												maxRows={2}
												placeholder={t('letsAddKpi')}
												InputProps={{ 'aria-label': t('addDefaultKr'), disableUnderline: true }}
												// disabled={checkKrDIsable()}
												onChange={(e: any) => handleNewKeyResultChange(e.target.value, 'keyDescription', keyData)}
												error={keyData?.isKrNameError}
												helperText={
													keyData?.isKrNameError && keyData?.krNameErrorMsg ? (
														<>
															<ErrorIcon />
															{keyData?.krNameErrorMsg}
														</>
													) : (
														''
													)
												}
											/>
										</Box>
										<Box className='listing-add-kr card-toggle'>
											<KpiActions
												keyDetails={keyData}
												krIndex={keyIndex}
												showLoader={showLoader}
												setShowLoader={setShowLoader}
												mode={'Add'}
												defaultOkrFormDetails={{ myGoalsDetails: newKeyList }}
												setDefaultOkrFormDetails={(data: any) => {
													setNewKeyList(data.myGoalsDetails);
												}}
												newKeyList={newKeyList}
											/>
										</Box>
									</Box>
								</ListItem>
								<ListItem className='okr-col2 '>
									<KpiProgressBarMain
										{...props}
										loginUserAvatar={{
											...keyData,
											goalStatusId: Enums.GOAL_STATUS_DRAFT,
											krId: keyData.goalKeyId,
											goalKeyId: keyData.goalKeyId,
										}}
										parentOkr={{ ...objData, goalStatusId: 2 }}
										okr={{
											...keyData,
											goalStatusId: Enums.GOAL_STATUS_DRAFT,
											krId: keyData.goalKeyId,
											goalKeyId: objData.goalObjectiveId,
										}}
										kr={{
											...keyData,
											goalStatusId: Enums.GOAL_STATUS_DRAFT,
											krId: keyData.goalKeyId,
											goalKeyId: keyData.goalKeyId,
										}}
										type={'kr'}
										t={t}
										updateProgress={updateProgress}
										showEditLoader={false}
										currentUser={userDetail}
										okrMasterData={okrMasterData}
										showArchiveList={false}
										isScoreLocked={false}
										enqueueSnackbar={() => {}}
										isAnyDrawerOpened={false}
										appDrawerInfo={props.appDrawerInfo}
										setOpenKrId={() => {}}
										setErrorOpen={() => {}}
										errorOpen={false}
										isEditable={false}
									/>
								</ListItem>
							</List>
						</Box>
					</Box>
				))}
		</>
	);
};

export default AddNewKpiKr;
